import React from 'react';
import { withStyles } from '@mui/styles';
import Scrollbars from 'react-custom-scrollbars-2';

const cardStyles = theme => ({
  root: {
    margin: 'auto',
    textAlign: 'left',
    width: '100%',
    minWidth: '320px',
  },
  limitedWidth: {
    margin: 'auto',
    textAlign: 'left',
    maxWidth: '1000px',
    width: '100%',
    minWidth: '320px',
  }
});

const ScrollableContentCard = ({ classes, children, limitedWidth }) => (
  <React.Fragment>
    <Scrollbars id="scroll-bars">
        <div className={limitedWidth ? classes.limitedWidth : classes.root}>{children}</div>
    </Scrollbars>
  </React.Fragment>
);

export default withStyles(cardStyles)(ScrollableContentCard);

export const Padding = withStyles({ padded: { padding: 15 } })(({ classes, children }) => <div className={classes.padded}>{children}</div>);
